import {Box, Typography} from "@mui/material";
import React from "react";
import NoDataImg from "../../../Common/NoData";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import FetchSignedUrl from "../../../Component/URL_Generator";

export default function Certification({data}) {
    return (
        <Box
            sx={{
                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                width: "100%",
                maxHeight: {md: "calc(100vh - 350px)"},
                // minHeight: '350px',
                overflow: {md: "scroll"},

                borderRadius: "8px",
            }}
            className="HideScrollBar"
        >
            <Typography
                sx={{
                    p: "1rem",
                    background:
                        "linear-gradient(181.45deg, #7AACFF -80.86%, rgba(60, 117, 213, 0.98) 98.77%)",
                    color: "white",
                    height: "50px",
                    position: "sticky",
                    top: "0",
                    zIndex: 1,
                    borderTopLeftRadius: "8px",
                    borderTopRightRadius: "8px",
                }}
            >
                Certifications
            </Typography>

            <Box sx={{height: "calc(100% - 50px)", overflow: "scroll"}}>
                {/* ================= Certificates ================= */}
                {data?.certications?.certificate?.length > 0 ? (
                    <Box sx={{p: 2}}>
                        {data.certications.certificate.map((certi, i) => {
                            const file = certi?.certificate_file ?? "";
                            const ext = file ? file.split(".") : [];
                            const status = certi?.status;

                            if (status !== 1) return null;

                            const newURL = file
                                ? file.replace(
                                    "https://instatrainme-api.s3.amazonaws.com/",
                                    ""
                                )
                                : "";

                            const imgURL = newURL ? FetchSignedUrl({path: newURL}) : "";

                            return (
                                <Box
                                    key={i}
                                    sx={{
                                        borderRadius: "8px",
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                    }}
                                >
                                    <Typography>{certi?.certificate_name}</Typography>

                                    {/* ✅ Show only if file exists */}
                                    {file && imgURL && (
                                        <Box
                                            sx={{
                                                p: 1,
                                                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                                                width: "200px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "8px",
                                            }}
                                        >
                                            <a
                                                href={imgURL}
                                                target="_blank"
                                                rel="noreferrer"
                                                style={{
                                                    color: "black",
                                                    textDecoration: "none",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "0.2rem",
                                                    position: "relative",
                                                }}
                                            >
                                                <InsertDriveFileIcon style={{color: "#ea0606"}}/>
                                                <span
                                                    style={{
                                                        fontSize: "0.4rem",
                                                        color: "white",
                                                        position: "absolute",
                                                        paddingTop: "11px",
                                                        left: 5,
                                                        letterSpacing: "1px",
                                                    }}
                                                >
                    {ext[ext.length - 1]?.toUpperCase()}
                  </span>
                                                <span style={{fontWeight: 500, fontSize: "14px"}}>
                    {`Certificate ${i > 0 ? i : ""}`}
                  </span>
                                            </a>
                                        </Box>
                                    )}

                                    <hr
                                        style={{
                                            background: "#CECECE",
                                            opacity: "0.3",
                                            margin: "1rem 0 .5rem 0",
                                            display:
                                                data.certications.certificate.length - 1 !== i
                                                    ? "block"
                                                    : "none",
                                        }}
                                    />
                                </Box>
                            );
                        })}
                    </Box>
                ) : (
                    <Box sx={{padding: "1rem", width: "100%", height: "100%"}}>
                        <NoDataImg/>
                    </Box>
                )}

                {/* ================= Vaccine Certificates ================= */}
                <Typography sx={{p: 1, background: "#EFEFEF"}}>
                    Vaccine Certificate
                </Typography>

                {data?.certications?.vaccine_certificate?.length > 0 ? (
                    <Box sx={{p: 2}}>
                        {data.certications.vaccine_certificate.map((certi, i) => {
                            const file = certi?.vaccine_certificate_file ?? "";
                            const ext = file ? file.split(".") : [];
                            const status = certi?.status;

                            if (status !== 1) return null;

                            const newURL = file
                                ? file.replace(
                                    "https://instatrainme-api.s3.amazonaws.com/",
                                    ""
                                )
                                : "";

                            const imgURL = newURL ? FetchSignedUrl({path: newURL}) : "";

                            return (
                                <Box
                                    key={i}
                                    sx={{
                                        borderRadius: "8px",
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                    }}
                                >
                                    {/* ✅ Show only if file exists */}
                                    {file && imgURL && (
                                        <Box
                                            sx={{
                                                p: 1,
                                                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                                                width: "200px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "8px",
                                            }}
                                        >
                                            <a
                                                href={imgURL}
                                                target="_blank"
                                                rel="noreferrer"
                                                style={{
                                                    color: "black",
                                                    textDecoration: "none",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "0.2rem",
                                                    position: "relative",
                                                }}
                                            >
                                                <InsertDriveFileIcon style={{color: "#ea0606"}}/>
                                                <span
                                                    style={{
                                                        fontSize: "0.4rem",
                                                        color: "white",
                                                        position: "absolute",
                                                        paddingTop: "11px",
                                                        left: 5,
                                                        letterSpacing: "1px",
                                                    }}
                                                >
                    {ext[ext.length - 1]?.toUpperCase()}
                  </span>
                                                <span style={{fontWeight: 500, fontSize: "14px"}}>
                    {`Certificate ${i > 0 ? i : ""}`}
                  </span>
                                            </a>
                                        </Box>
                                    )}

                                    <hr
                                        style={{
                                            background: "#CECECE",
                                            opacity: "0.3",
                                            margin: "1rem 0 .5rem 0",
                                            display:
                                                data.certications.vaccine_certificate.length - 1 !== i
                                                    ? "block"
                                                    : "none",
                                        }}
                                    />
                                </Box>
                            );
                        })}
                    </Box>
                ) : (
                    <Box sx={{padding: "1rem", width: "100%", height: "100%"}}>
                        <NoDataImg/>
                    </Box>
                )}
            </Box>
        </Box>
    );
}
